import { Buffer } from 'buffer';
import process from 'process';

(window as any).global = window;
window.Buffer = window.Buffer || Buffer;
window.process = window.process || process;
